export default function toUpperCase(str: string): string {
  return str.toUpperCase();
}
